import React, { memo } from 'react';
import { areEqual } from 'react-window';
import { isFunction, isUndefined } from 'lodash';
import { areSectionsEqual } from '../shared/sectionsWithCounters';
import { findSectionForRow } from '../shared';

export const getItemClassName = (section, itemProps) =>
  section.itemClass ? (isFunction(section.itemClass) ? section.itemClass(itemProps) : section.itemClass) : '';

export const renderLayoutItem = ({ section, itemProps, index, cols }) => {
  return !isUndefined(index) ? (
    <div className={getItemClassName(section, itemProps)} style={itemProps.style}>
      {section.renderItemComponent(itemProps, index, cols)}
    </div>
  ) : null;
};

//export for testing purposes
export const getLayoutItemComponent = (getItemProps, rowProp) => (props) => {
  let result = null;
  const { sections, cols } = props.data;

  const section = findSectionForRow(sections, props[rowProp]);

  if (section) {
    const sectionItemProps = section.itemProps || {};
    //need to offset the section's position within the layout
    const rowIndex = props[rowProp] - section.startRow;
    //we use the style from the Windowed Grid but allow overrides
    const style = { ...props.style, ...sectionItemProps.style };

    const itemProps = {
      ...props,
      ...sectionItemProps,
      rowIndex,
      //additional overrides can be applied using section's getItemStyle
      style: section.getItemStyle
        ? section.getItemStyle(style, {
            ...sectionItemProps,
            rowIndex,
          })
        : style,
    };

    const params = getItemProps ? getItemProps(section, itemProps, cols) : { index: rowIndex, itemProps };

    result = renderLayoutItem({ section, cols, itemProps, ...params });
  }

  return result;
};

export const checkPropsEquality = (prevProps, nextProps) => {
  const propsEqual = areEqual(
    {
      ...prevProps,
      ...prevProps.data,
      data: null,
      sections: null,
    },
    {
      ...nextProps,
      ...nextProps.data,
      data: null,
      sections: null,
    }
  );

  return propsEqual && areSectionsEqual(prevProps.data.sections, nextProps.data.sections);
};

/**
 * creates a memoized layout item (function) component
 */
export default (rowProp, getItemProps) => {
  return memo(getLayoutItemComponent(getItemProps, rowProp), checkPropsEquality);
};
